import { mapGetters, mapMutations } from 'vuex';
import { plansof } from '@/utils/chain';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import _ from 'lodash';

export default {
  computed: {
    ...mapGetters([
      'allPbxPlans',
      'allPbxBasePlans',
      'selectedAllPbxPlans',
      'selectedPbxNonBasePlans',
      'selectedPbxBasePlans',
      'selectedPbxBasePlan',
      'selectedTFPlans',
      'selectedTFPlan',
      'pbxBasePlansGroupByBillingCycle',
      'boughtPbxBasePlan',
      'getSelectedPlans',
      'planMapFlat'
    ]),
    selectedZoneProPlusCallingPlans() {
      return plansof(this.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).plans;
    },
    selectedZoneProPlusCallingPlan() {
      return _.get(this.selectedZoneProPlusCallingPlans, [0]);
    },
    zoneBundleCallingPlanList() {
      return plansof(this.planMapFlat).type(planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE).get();
    },
    similarPbxPlanList() {
      return [...this.zoneBundleCallingPlanList, ...this.allPbxPlans];
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan','setPbxBasePlanCode','setPbxBillingCycle']),
    getSelectedCategoryNumberMap() {
      return _.reduce(
        [...this.selectedZoneProPlusCallingPlans, ...this.selectedPbxNonBasePlans],
        (pre, item) => {
          return {
            ...pre,
            [item.category]: item.cartInfo.selected_number,
          };
        }, {});
    },
    getSelectedBasePlanCategoryNumberMap() {
      return _.reduce(this.selectedPbxBasePlans, (pre, item) => {
        return {
          ...pre,
          [item.category]: item.cartInfo.selected_number,
        };
      }, {});
    },
    switchPlansBillingCycle(categoryNumberMap, billingCycle) {
      this.similarPbxPlanList
        // get selected plans
        .filter(item => categoryNumberMap[item.category])
        // remove selected plans
        .forEach(item => this.removePlan(item.plan_code));
      // get plans by billing cycle

      this.similarPbxPlanList
        .filter(item => categoryNumberMap[item.category] && item.billing_cycle === billingCycle)
        // add plan to cart
        .forEach(item => {
          if (categoryNumberMap[item.category]) {
            this.updateSelectPlan({
              plan_code: item.plan_code,
              cartInfo: { selected_number: categoryNumberMap[item.category] },
            });

            categoryNumberMap[item.category] = 0;
          }
        });
    },
    switchPbxAddonAndBasePbx(billingCycle){
      this.setPbxBillingCycle(billingCycle);
      const selectedBasePlanCategoryNumberMap = this.getSelectedBasePlanCategoryNumberMap();
      const selectedCategoryNumberMap = this.getSelectedCategoryNumberMap();
      this.switchPlansBillingCycle(selectedCategoryNumberMap, billingCycle);
      if (this.selectedPbxBasePlan?.billing_cycle !== BILLING_CYCLE.PAY_AS_YOU_GO) {
        this.switchPlansBillingCycle(selectedBasePlanCategoryNumberMap, billingCycle);
        this.setPbxBasePlanCode(this.selectedPbxBasePlan.plan_code);
      }
    }
  }
};
